import { makeStyles, Theme } from '@material-ui/core/styles'

const FONT_SIZE = 16
const FONT_SIZE_SM = 13

export default makeStyles((theme: Theme) => ({
  root: {
    borderRadius: 40,
    backgroundColor: '#E0E0E0'
  },
  box: {
    padding: '8px 40px 2px 21px'
  },
  avatar: {
    height: 80,
    width: 80,
    backgroundColor: theme.palette.common.lightPurple,
    '& > img': {
      height: 80,
      width: 80
    }
  },
  h3: {
    color: '#323232',
    fontSize: FONT_SIZE,
    fontWeight: 300,
    lineHeightStep: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: FONT_SIZE_SM
    }
  },
  body1: {
    color: '#323232',
    fontSize: FONT_SIZE,
    fontWeight: 300,
    lineHeightStep: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: FONT_SIZE_SM
    }
  },
  body2: {
    color: '#323232',
    fontSize: FONT_SIZE,
    fontWeight: 300,
    lineHeightStep: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: FONT_SIZE_SM
    }
  }
}))
